<template>
  <div class="about"> 
    <div class="loadig" v-if="isLoading">
      <img src="../assets/loading.gif">
    </div>
    <div class="header">
      <a href="/">主页</a>
      <span class="divider">/</span>
    </div>
    <main>
      <section class="sec">
        <h1 class="ch1">关于 cnode_vue</h1>
        <p class="cp">
          本项目使用Vue来仿写cnode社区，用vue-cli来搭建项目模板，利用cnode官方提供的社区API，使用Axios来获取数据，
          并且用Vue Router来进行路由的转换和传参，使用watch监听路由的变化，用webpack来进行打包。
        </p>
        <p class="cp">
          技术栈：<strong>Vue-cli/Vue2/Vue Router/Axios/ES6/NPM</strong>
        </p>
        <p class="cp">其中包括了PostList 主列表、Aticle文章详情页、SlideBar 侧边栏、UserInfo 用户个人信息和Pagination 分页组件等</p>
      </section>
    </main>

  </div>
</template>

<script>
export default {
  name:'About',
  data(){
    return{
      isLoading:false
    }
  }
}
</script>

<style scoped>
.loading {
  text-align: center;
  padding-top: 300px;
}
.about{
  border-radius: 3px;
  height: 83.1vh;
  background: white;
  margin-left: auto;
  margin-right: auto;
  font-size: 14px;
}
.header {
  padding: 10px;
  background-color: #f6f6f6;
}
.divider {
  padding: 0 5px;
  color: #ccc;
}
.main{
  padding: 10px;
}
.sec{
  margin: 10px;
}
.ch1{
  padding-bottom: 8px;
  border-bottom: 2px solid #e5e5e5;
}
.cp{
  font-size: 15px;
  line-height: 2em;
  overflow: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/About.vue